import { jsx as _jsx } from "react/jsx-runtime";
import { cn } from '../../../utils';
export function TableContainer({ children, className }) {
    return (_jsx("div", { className: cn('overflow-y-auto rounded-card bg-surface-muted p-stack-section flex flex-col gap-stack-roomy h-fit max-h-full', className), children: children }));
}
